/* actionTypes */
import { SET_INITIALIZED, SET_COOKIE } from "../actionTypes/appActionTypes";

/* actionCreators */
import { fetchUserData } from "./userDataActionCreator";

export const setInitialized = (data) => ({
  type: SET_INITIALIZED,
  payload: data,
});
export const setCookieExisted = (data) => ({
  type: SET_COOKIE,
  payload: data,
});

export function initialize() {
  return (dispatch) => {
    const userData = dispatch(
      fetchUserData({ c: "accountStore", a: "profileData" })
    );
    Promise.all([userData]).then(() => {
      dispatch(setInitialized(true));
    });
  };
}
